// extracted by mini-css-extract-plugin
module.exports = {"responseMessageContainer":"ResponseMessage_responseMessageContainer__11w_b"};